import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import { DealRating } from '~/components/product';
import { DealReview } from '~/types/deal';

interface IProductDetailRating {
  dealReview: DealReview;
  reviewUrl?: string;
  PDPUrl: string;
}

function ProductDetailRating({
  dealReview,
  reviewUrl,
  PDPUrl,
}: IProductDetailRating) {
  return (
    <div className="mb-4 flex items-center gap-2 text-sm font-medium">
      <DealRating
        averageRating={dealReview.average_rating}
        reviewCount={dealReview.review_count}
        href={reviewUrl ?? PDPUrl}
        isAggregatePage
      />
      <span className="text-gray-400 lg:hidden">&#124;</span>
      <Link
        href={PDPUrl}
        target="_blank"
        className="flex items-center text-blue-600 hover:underline lg:hidden"
      >
        Product details
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ml-2" />
      </Link>
    </div>
  );
}

export default ProductDetailRating;
